export const OLD_FLOW = {name:"old",releaseVersion:"9.4.0"}
export const NEW_FLOW = {name:"new",releaseVersion: "11.1.0"}